<template>
  <div class="area-content">
    <div class="area-content__heading">
      <div
        v-for="(choice, i) in choices"
        :key="i"
        @click="currentChoice = choice"
        :class="[
          'area-content__filter',
          choice === currentChoice && ' area-content__filter--selected',
        ]"
      >
        {{ choice }}
      </div>
    </div>
    <FilteredCourses
      v-if="content && content.length"
      :content="content"
      :filter="currentChoice"
      :learningAreaName="learningAreaName"
      :isFreeTrialUser="isFreeTrialUser"
      :swiperClass="swiperClass"
    />
  </div>
</template>

<script>
import { createIndices } from '@/services/search'
import FilteredCourses from '@/components/learning-area/FilteredCourses.vue'

export default {
  name: 'AreaContent',
  components: {
    FilteredCourses,
  },
  data() {
    return {
      choices: [],
      currentChoice: '',
      indices: {
        Popular: {},
        'New Courses': {},
        'Learning Paths': {},
      },
      results: {
        Popular: [],
        'New Courses': [],
        'Learning Paths': [],
      },
    }
  },
  props: {
    learningAreaName: {
      type: String,
      required: true,
    },
    algoliaKeys: {
      type: Object,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
    isShowingLearningPaths: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    content() {
      return this.results[this.currentChoice]
    },
    swiperClass() {
      if (this.currentChoice === 'Learning Paths') {
        return 'learningpaths'
      }
      if (this.currentChoice === 'New Courses') {
        return 'newcourses'
      }
      return 'popular'
    },
  },
  methods: {
    handleResults(index, { hits }) {
      this.results[index] = hits
    },
    createSearchInstance() {
      const {
        algoliaKeys: {
          appKey,
          appId,
          coursesIndex: courses,
          learningPathsIndex: learningPaths,
        },
      } = this
      const contexts = []
      this.choices.map(choice => {
        contexts.push({
          name: choice,
          index: choice === 'Learning Paths' ? learningPaths : courses,
          facets:
            choice === 'Popular'
              ? ['learning_areas.name', 'is_popular']
              : ['learning_areas.name'],
        })
      })
      const setup = {
        keys: {
          appId,
          appKey,
        },
        contexts,
        resultsHandler: this.handleResults,
      }
      const parentFilter = {
        facet: 'learning_areas.name',
        value: this.learningAreaName,
      }
      const { indices } = createIndices(setup, parentFilter)
      this.indices = indices
    },
  },
  created() {
    this.choices = this.isShowingLearningPaths
      ? ['Learning Paths', 'Popular', 'New Courses']
      : ['Popular', 'New Courses']
    this.currentChoice = this.isShowingLearningPaths
      ? 'Learning Paths'
      : 'Popular'
    this.createSearchInstance()
    this.indices.Popular.addFacetRefinement('is_popular', 'true')
    this.indices.Popular.search()
  },
}
</script>

<style lang="scss" scoped>
.area-content {
  min-height: 305px;
  padding: 0 10px;
  &__heading {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 0 0 20px 0;
  }
  &__filter {
    color: var(--white);
    text-transform: uppercase;
    font-size: 1rem;
    font-weight: 700;
    transition: 0.5s all ease;
    margin: 0 auto;
    width: 100%;
    text-align: center;
    border: 1px solid var(--white);
    @include mobile {
      border: none;
      text-align: unset;
      width: auto;
    }
    @include tablet {
      white-space: nowrap;
      max-height: 25px;
      margin: 0 25px 5px 0;
    }
    &:hover {
      cursor: pointer;
      color: var(--orange);
    }
    &--selected {
      color: var(--orange);
      @include mobile {
        color: inherit;
        border-bottom: 1px solid #ef7d22;
      }
    }
  }
}
</style>
